import React, { useEffect, useState } from 'react';

interface IBreakpoint {
    name: string,
    isMobile: boolean,
    isDesktop: boolean,
    isTablet: boolean,
    minWidth: number,
    maxWidth: number,
    nextBreakpoint?: IBreakpoint,
    previousBreakpoint?: IBreakpoint
}

const Breakpoints = [] as IBreakpoint[];

Breakpoints.push({ name: "xs", isMobile: true, isTablet: false, isDesktop: false, minWidth: 1, maxWidth: 414 });
Breakpoints.push({ name: "sm", isMobile: true, isTablet: false, isDesktop: false, minWidth: 415, maxWidth: 600 });
Breakpoints.push({ name: "md", isMobile: false, isTablet: true, isDesktop: false, minWidth: 601, maxWidth: 800 });
Breakpoints.push({ name: "lg", isMobile: false, isTablet: true, isDesktop: true, minWidth: 801, maxWidth: 1024 });
Breakpoints.push({ name: "xl", isMobile: false, isTablet: false, isDesktop: true, minWidth: 1025, maxWidth: 1440 });
Breakpoints.push({ name: "xxl", isMobile: false, isTablet: false, isDesktop: true, minWidth: 1441, maxWidth: 999999999 });

Breakpoints.forEach(bp => {
    bp.nextBreakpoint = Breakpoints.find(f => f.minWidth === bp.maxWidth + 1);
    bp.previousBreakpoint = Breakpoints.find(f => f.maxWidth === bp.minWidth - 1);
});

export const useBreakpoint = () => {
    const getBreakpoint = () => {
        var bp = Breakpoints.find(i => i.minWidth <= innerWidth && i.maxWidth > window.innerWidth);

        if (!bp) {
            console.log("no breakpoint for " + window.innerWidth);
        }

        return bp;
    }

    const [currentBreakpoint, setCurrentBreakpoint] = useState(getBreakpoint());

    useEffect(() => {
        const onResize = () => {
            var bp = getBreakpoint();

            if (!(bp?.name === currentBreakpoint?.name)) {
                setCurrentBreakpoint(bp);
            }
        };

        window.addEventListener('resize', onResize);

        return () => {
            window.removeEventListener('resize', onResize);
        }
    });

    return currentBreakpoint;
};